import { apiRoutes } from '../config/api'
import type { SongSearchResult, ToneSignatureResultDto } from '../models/toneSignature'
import { get } from './httpClient'

export function searchSongs(artist: string, title: string, signal?: AbortSignal) {
  const params = new URLSearchParams()
  if (artist.trim()) {
    params.set('artist', artist.trim())
  }

  if (title.trim()) {
    params.set('title', title.trim())
  }

  return get<SongSearchResult[]>(`${apiRoutes.songsSearch}?${params.toString()}`, signal)
}

export function getSongToneSignature(songId: string, signal?: AbortSignal) {
  return get<ToneSignatureResultDto>(apiRoutes.songToneSignature(songId), signal)
}
